import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import { camelizeKeys } from "lib/helpers";
import messages from "../messages";

type GetCrmActivityParamsT = {
  payload: {
    activityId: number;
  };
};

function* getCrmActivity(action: GetCrmActivityParamsT) {
  const { activityId } = action.payload;

  const { success, data, error } = yield* makeRequest.get(`/sales_enablement_activities/${activityId}`, {});

  if (success && data) {
    yield put(actions.setCrmActivityDetails(camelizeKeys(data.body)));
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_CRM_ACTIVITY,
    });
  }
  return null;
}

export default getCrmActivity;
